/**
 * MAL-Sync — sync anime/manga progress with MyAnimeList and others
 *
 * Declares one web-accessible-resource entry — vendor/*, assets/*, icons/*,
 * content/proxy/* and window.html — matched to every origin with no use_dynamic_url,
 * so all of those files are fetchable from any page at a stable URL.
 *
 * The icon loads through probeImage with no CORS grant. The per-service proxy scripts
 * (proxy_Netflix.js and friends) are vendor-named and distinctive to this extension.
 *
 * Manifest verified against version 0.12.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kekjfbackdeiabghhcdklcdoekaanoel';

export const malSync: ExtensionDefinition = {
  id: ID,
  name: 'MAL-Sync',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'icons/, content/proxy/ and more exposed to every origin with no dynamic URL. The ' +
    'icon is CORS-free and the vendor-named proxy scripts are conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon128.png via <img> — exposed to every origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon128.png'),
    },
    {
      id: 'war-proxy-netflix-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/proxy/proxy_Netflix.js — a vendor-named per-service proxy script, ' +
        'distinctive to MAL-Sync.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/proxy/proxy_Netflix.js'),
    },
    {
      id: 'war-window-html',
      kind: 'web-accessible-resource',
      description: 'Fetch window.html — the popup window page, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'window.html'),
    },
  ],
};
